module.exports = __webpack_public_path__ + "flUhRq6tzZclQEJ-Vdg-IuiaDsNc.53436aca8627a49f4dea.woff2";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/src/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2
// module id = ../../../../../src/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2
// module chunks = 2